import {
  MultiSelectDropBoxWithPills,
  MultiSelectDropBoxWithPillsProps,
} from '../../../core/POS/MultiSelectDropBoxWithPills';
import {
  useListingNotesSelector,
  UseListingNotesSelectorOptions,
} from './useListingNotesSelector';

export type ListingNotesSelectorProps = Omit<
  MultiSelectDropBoxWithPillsProps,
  'valueOptionsContent'
> &
  UseListingNotesSelectorOptions;

export function ListingNotesSelector({
  disabled,
  additionalOptions,
  additionalOptionsPosition,
  ...props
}: ListingNotesSelectorProps) {
  const { multiSelectorProps } = useListingNotesSelector({
    additionalOptions,
    additionalOptionsPosition,
    disabled,
  });
  return (
    <MultiSelectDropBoxWithPills
      {...props}
      disabled={disabled}
      {...multiSelectorProps}
    />
  );
}
